import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import { Button } from 'react-bootstrap';
import axios from "axios";
import { BiMapPin } from 'react-icons/bi';
import JSONPretty from 'react-json-pretty';
var JSONPrettyMon = require('react-json-pretty/dist/monikai');


const Prova_codice = () => {
//    const [somma, calcola_somma] = useState('');
    const [lista, SET_lista] = useState([]);


    const Progetti_lookup_attivi_alfabetico = () => {
        var utente = 'utente_unico'
        console.log('Progetti_lookup_alunni_in_alfabetico -----------------------')

        let classe_selezionata = '662cbf943299f53f02e0fcdf'

           /* idroslab */
     
        axios.get('/classi/classi_progetti_entro_un_periodo_alfabetico/' , {
            params: {
                utente: 'utente_unico',
                classe_selezionata: classe_selezionata,
                data_selezionata: new Date(),
                show_bottone: 'data_la_classe_carica_progetti_attivi'
            }
        }) 
        .then((res) => {
            console.log('-----------------------')

            console.log('CLASSI appena fecciate da mongo')
            console.log(res.data)
            const lista_ridotta = res.data

               /* idroslab */
     
                lista_ridotta.forEach(function (element) {
                    element.presenze = "XXXXXXXXXXXXXXXXXXXXXX TOLTO_DA_PAOLO";
                    element.valutazione = "XXXXXXXXXXXXXXXXXXXXXX TOLTO_DA_PAOLO";

                });

            SET_lista(lista_ridotta)
    //            report_progetti_attivi(res.data)
        }).catch((error) => {
            console.log(error) 
        });
    }


    const Progetti_lookup_alunni_in_alfabetico = () => {
        var utente = 'utente_unico'
        console.log('Progetti_lookup_alunni_in_alfabetico -----------------------')

        let classe_selezionata = '662cbf943299f53f02e0fcdf'

        axios.get('/classi/classi_progetti_entro_un_periodo_alfabetico/' , {
            params: {
                utente: 'utente_unico',
                classe_selezionata: classe_selezionata,
                anno_selezionato: 2022
            }
        }) 
        .then((res) => {
            console.log('-----------------------')

            console.log('CLASSI appena fecciate da mongo')
            console.log(res.data)
            const lista_ridotta = res.data

                lista_ridotta.forEach(function (element) {
                    element.presenze = "XXXXXXXXXXXXXXXXXXXXXX TOLTO_DA_PAOLO";
                    element.valutazione = "XXXXXXXXXXXXXXXXXXXXXX TOLTO_DA_PAOLO";

                });

            SET_lista(lista_ridotta)
    //            report_progetti_attivi(res.data)
        }).catch((error) => {
            console.log(error) 
        });
    }

    const Prova_per_invio_mail = () => {
        console.log('Carica_domande_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        /* idroslab */
     
        axios.get('/ditte/ditte_prova_invio_mail/' + utente)
            .then((res) => {
                console.log('domande appena fecciate da mongo')
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }

    const Prova_invio_report = () => {
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        /* idroslab */
     
        axios.get('/progetti/x3/' + utente)
            .then((res) => {
                console.log('sdgfedfg da mongo')
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }

    return (
    <div>
        <Button onClick={() => Progetti_lookup_attivi_alfabetico()}>  <BiMapPin /> XXX Progetti_alunni in alfabetico (Funziona solo 2022 e per una certa classe)</Button>
        {/* idroslab */}
     
        <Button onClick={() => Progetti_lookup_alunni_in_alfabetico()}>  <BiMapPin /> Progetti_alunni in alfabetico (Funziona solo 2022 e per una certa classe)</Button>
        <Button onClick={() => Prova_per_invio_mail()}>  <BiMapPin /> Prova per invio mail</Button>
        <Button onClick={() => Prova_invio_report()}>  <BiMapPin /> Prova per report</Button>
        {/* (props.account_dati.utente_debug) &&
        
            <JSONPretty data={lista} />
        */}                  
        <JSONPretty data={lista} theme={JSONPrettyMon}/>

    </div>
    )
}
export default Prova_codice;